import cookieUtils from '@s-ui/js/lib/cookie'

import {
  EMAIL_LEAD_TYPES,
  LEAD_EVENT,
  OEM_LEAD_TYPES,
  PHONE_LEAD_TYPES,
  PROFESSIONAL_SELLER_TYPE,
  SEGMENT_ANONYMOUS_COOKIE_KEY,
  SUBSCRIPTION_LEAD_PROPERTIES,
  TEST_SUBDOMAINS
} from './config.js'

export const isClient = typeof window !== 'undefined'
export const isProd = isClient && Boolean(window.location.hostname.match(/^www.|^motos./))
export const isCoches = isClient && !window.location.hostname.includes('motos')
export const isTestDomain =
  isClient && TEST_SUBDOMAINS.some(subdomain => window.location.hostname.startsWith(subdomain))

export const environment = isProd ? 'production' : 'development'
export const site = isCoches ? 'coches' : 'motos'

export const log = console.log // eslint-disable-line no-console
export const warn = console.warn // eslint-disable-line no-console

export const required = parameter => {
  throw new Error(`${parameter} is a required parameter.`)
}

export const loadIframe = attributes => {
  const iframe = document.createElement('iframe')

  Object.keys(attributes).forEach(attribute => {
    const value = attributes[attribute]

    iframe.setAttribute(attribute, value)
  })
  document.body.appendChild(iframe)
}

export const checkEmailLeadEvent = ({event, properties}) => {
  const {lead_type: leadType} = properties

  if (event === LEAD_EVENT) {
    return EMAIL_LEAD_TYPES.includes(leadType)
  }
}

export const checkOEMLeadEvent = ({event, properties}) => {
  const {lead_type: leadType} = properties

  if (event === LEAD_EVENT) {
    return OEM_LEAD_TYPES.includes(leadType)
  }
}

export const checkSubscriptionLeadEvent = ({properties}) => {
  // the presence of monthly_subscription_fee as a property identifies this lead as it's a Subscription lead event
  const {[SUBSCRIPTION_LEAD_PROPERTIES.MONTHLY_SUBSCRIPTION_FEE]: monthlySubscriptionFee} = properties
  return monthlySubscriptionFee !== undefined
}

export const checkPhoneLeadEvent = ({event, properties}) => {
  const {lead_type: leadType} = properties

  if (event === LEAD_EVENT) {
    return PHONE_LEAD_TYPES.includes(leadType)
  }
}

export const checkProfessionalSellerType = ({properties}) => {
  const {seller_type: sellerType} = properties

  return sellerType?.toLowerCase() === PROFESSIONAL_SELLER_TYPE
}

export const getAnonymousId = () => {
  const cookies = window.document.cookie

  if (typeof cookies !== 'string') return
  const {parse} = cookieUtils
  const {[SEGMENT_ANONYMOUS_COOKIE_KEY]: anonymousIdCookie} = parse(cookies)

  return anonymousIdCookie
}
